import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useTheme } from '../context/ThemeContext';

interface ThemeToggleProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  size = 'medium', 
  color = 'inherit' 
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={toggleTheme}
        size={size}
        color={color}
        sx={{
          transition: 'all 0.2s ease',
          '&:hover': {
            transform: 'scale(1.1)',
            backgroundColor: 'action.hover',
          },
        }}
      >
        {isDarkMode ? (
          <LightMode 
            sx={{ 
              color: '#fbbf24',
              filter: 'drop-shadow(0 0 6px rgba(251, 191, 36, 0.3))',
            }} 
          />
        ) : (
          <DarkMode 
            sx={{ 
              color: '#6366f1',
              filter: 'drop-shadow(0 0 6px rgba(99, 102, 241, 0.3))',
            }} 
          />
        )}
      </IconButton>
    </Tooltip>
  );
};